import React from 'react';

interface IconProps extends React.HtmlHTMLAttributes<HTMLButtonElement> {
    icon: string
    size?: string
    tintColor?: string
    withoutWrapper?: boolean
}

export const IconSVG = ({
                            icon,
                            size = '32px',
                            tintColor,
                            withoutWrapper = false,
                            ...rest
                        }: IconProps) => {
    const image = icon ? `${process.env.REACT_APP_LOAD_CONFIG}assets/icons/svg/${icon}.svg` : ''

    const iconTemplate = tintColor ? (
        <div
            className="icon icon-svg-mask"
            style={{
                maskImage: `url(${image})`,
                WebkitMaskImage: `url(${image})`,
                backgroundColor: tintColor,
                width: size,
                height: size,
            }}
        ></div>
    ) : (
        <img className="icon" src={image} width={size} height={size}/>
    )

    if (withoutWrapper) {
        return iconTemplate
    }

    return (
        <span {...rest}>
      {iconTemplate}
    </span>
    )
}
